import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

// Format only date (in local time)
export const formatDate = (dateString) => {
  return dayjs.utc(dateString).local().format("DD.MM.YYYY");
};

// Format date + time
export const formatDateTime = (dateString, convertToLocal = false) => {
  if (convertToLocal) {
    // Convert from UTC → User's local timezone
    return dayjs.utc(dateString).local().format("DD.MM.YYYY | HH:mm");
  }
  // Keep UTC time
  return dayjs.utc(dateString).format("DD.MM.YYYY | HH:mm");
};
